import { Button, Theme, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
import { CustomTypography } from 'shared/elements/CustomTypography';

export const RoleItemCont = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? COLORS.CARD_DARK_GRAY : COLORS.LIGHT,
  border: `1px solid ${theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER}`,
  borderRadius: 10,
  padding: 10,
  '& .MuiTypography-root': {
    fontSize: 13,
    fontWeight: 'normal',
    // overflow: 'hidden',
    // textOverflow: 'ellipsis',
    // whiteSpace: 'nowrap',
  },
}));

export const RoleHeaderCont = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const TopCont = styled('div')(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: 10,
  },
}));

export const TitleCont = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 10,
  alignItems: 'center',
  flex: 1,
  justifyContent: 'space-between',
}));

export const BottomCont = styled('div')(({ theme }) => ({
  marginTop: 10,
  display: 'flex',
  borderTop: `1px solid ${theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER}`,
  gap: 20,
  padding: '10px 0 0 0',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: 10,
  },
}));

export const InfoCont = styled('div')<Theme, { width?: number; bordered?: number }>(({ theme, width, bordered }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  // marginRight: 20,
  justifyItems: 'center',
  flex: 1,
  minWidth: width,
  maxWidth: width,
  overflow: 'hidden',
  ...(bordered && {
    // borderLeft: `1px solid ${theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER}`,
    paddingLeft: 10,
  }),
  [theme.breakpoints.down('md')]: {
    borderLeft: 'none',
    paddingLeft: 0,
  },
  [theme.breakpoints.down('xs')]: {
    minWidth: width === 230 ? 'unset' : width,
    maxWidth: width === 230 ? 'unset' : width,
  },
}));

export const Label = styled(CustomTypography)(({ theme }) => ({
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
  whiteSpace: 'nowrap',
}));

export const ButtonCont = styled('div')(({ theme }) => ({
  marginLeft: 'auto',
  display: 'flex',
  height: '100%',
  gap: 10,
  alignItems: 'center',
  // borderLeft: `1px solid ${theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER}`,
  alignSelf: 'center',
}));

export const ActionButton = styled(Button)<Theme, { negative?: number }>(({ theme, negative }) => ({
  padding: '2px 10px',
  fontSize: 10,
  backgroundColor: 'transparent',
  borderColor: negative ? COLORS.ERROR : COLORS.PRIMARY,
  height: 24,
  minWidth: 80,
  [theme.breakpoints.down('sm')]: {
    padding: 0,
    height: 30,
  },
}));

export const NoteCont = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 20,
  minWidth: 100,
  flex: 1,
  overflow: 'hidden',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: 5,
  },
}));

export const Wrapper = styled('div')<Theme, { rolecontent?: number }>(({ theme, rolecontent }) => ({
  display: 'flex',
  flex: 1,
  overflow: 'hidden',
  gap: 10,
  ...(rolecontent && { flexDirection: 'column', gap: 0 }),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: 5,
  },
}));

export const DescriptionText = styled(CustomTypography)<Theme>(({ theme }) => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const RefCont = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 5,
  maxWidth: 220,
}));
